import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { SharedModule } from '../../../shared/shared.module';
import { NotificationComponent } from './components/notification/notification.component';
import { NotificationsService } from './notifications.service';
import { NotificationsScreenComponent } from './screens/notifications-screen/notifications-screen.component';

@NgModule({
  declarations: [NotificationsScreenComponent, NotificationComponent],
  imports: [CommonModule, SharedModule, HeaderComponent],
  providers: [NotificationsService],
})
export class NotificationsModule {}
